function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\u77E9\u5F62@1x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u7BA1\\u7406-\\u60AC\\u505C\\u5C55\\u793A",
  transform: "translate(-1282.000000, -109.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-12",
  transform: "translate(1272.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-9",
  transform: "translate(10.000000, 59.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.55555932,3 L15.2861004,3.17124911 C16.1416513,3.17124911 17,3.7000093 17,4.55556119 L17,4.55556119 L17,15.4444388 C17,16.3000076 16.2999915,17 15.4444407,17 L15.4444407,17 L4.55557623,17 C3.69224318,17 3,16.2999907 3,15.4444388 L3,15.4444388 L3,13.0319429 C3,12.6461115 3.31277814,12.3333333 3.69860953,12.3333333 C4.08444092,12.3333333 4.39721906,12.6461115 4.39721906,13.0319429 L4.39721906,13.0319429 L4.39721906,15.6156879 L15.6088305,15.6156879 L15.6088305,4.37033553 L4.39721906,4.37033553 L4.39721906,6.96805714 C4.39721906,7.35388853 4.08444092,7.66666667 3.69860953,7.66666667 C3.31277814,7.66666667 3,7.35388853 3,6.96805714 L3,6.96805714 L3,4.55556119 C3,3.69999239 3.69222626,3 4.55555932,3 L4.55555932,3 Z M8.90765106,6.94498799 C9.18661629,6.6920222 9.61153833,6.69046002 9.89235599,6.94136783 L9.89235599,6.94136783 L12.2543138,9.05175384 C12.6657572,9.41993058 12.7014352,10.0518631 12.3340478,10.4640115 L12.3340478,10.4640115 L10.0638407,13.0069634 C9.81472266,13.2860107 9.39371258,13.3285367 9.09382319,13.1049443 C9.08010283,13.0947146 9.06682104,13.0839096 9.05401336,13.072558 C8.80301238,12.8500938 8.77987876,12.4662744 9.00234296,12.2152735 L9.00234296,12.2152735 L10.5886527,10.4254786 L3.62455675,10.4254786 C3.27963292,10.4254786 3.00001692,10.1458626 3.00001692,9.80093874 C3.00001692,9.45601492 3.27963292,9.17639891 3.62455675,9.17639891 L3.62455675,9.17639891 L10.5886356,9.17639891 L8.92851949,7.81080561 C8.9070218,7.79312184 8.88684312,7.77389299 8.86814419,7.75327221 C8.65585219,7.51916116 8.67354002,7.15727999 8.90765106,6.94498799 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#8C8C8C",
  fillRule: "nonzero"
})))));

var SvgLogOut = function SvgLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/log_out.61c6eea9.svg";
export { ForwardRef as ReactComponent };